// extracted by mini-css-extract-plugin
export default {"three_dot_icon_btn":"recipeBannerMenu_three_dot_icon_btn__xPVFS"};